import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AdministrationRepo } from 'src/app/repositories/administration-repo';
import { Role } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-delete-role',
    templateUrl: './modal-delete-role.component.html',
    styleUrls: ['./modal-delete-role.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeleteRoleComponent{

  loading = false;
  deleteSuccess: any;
  deleteError: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public role: Role,
    private administrationRepo: AdministrationRepo,
    private translate: TranslateService
  ) { }

  deleteRole() {
    this.loading = true;
    this.administrationRepo
      .deleteRole(this.role.uid).toPromise()
        .then((response: any) => {
          this.loading = false;
          this.deleteSuccess = this.translate.instant('administration.roles.role_deleted');
        })
        .catch((error: any) => {
          this.loading = false;
          this.deleteError = this.translate.instant('administration.roles.error_role_deleted');
        });
  }

  ngOnDestroy(): void {
  }

}
